// extracted by mini-css-extract-plugin
export var label = "_eq-0";
export var treatmentCard = "_eq-1";